import client from "./client";

const getWalletAddress = (type: number, protocol: string) => client.post("/dc/getWalletAddress", {type, protocol});

const getChargeActivity = () => client.post("/getCurrentChargeActivity");

const updateChargeActivityFlag = (isJoin: boolean) => client.post("/updateChargeActivityFlag", {chargeActivityFlag: isJoin ? 0 : 1});

const depositFiat = (data: Record<string, string | number>) => client.post("/v2/payment/order/apply", data);

const withdrawCrypto = (data: {type: number; protocol: string; amount: number; dstwalletaddr: string; twoFaCode?: number}) => client.post("/dc/transfer", data);

const withdrawFiat = (data: object) => client.post("/v2/transfer/order/submit", data);

const getSwapRate = (type: number, dstType: number) => client.post("/getSwapRate", {type, dstType});

const swapCoin = (type: number, amount: number, dstType: number) =>
    client.post("/swapCoin", {
        type,
        amount,
        dstType,
        dstUserId: 0,
    });

const queryChargeLog = (type: number, pageId: number, itemCount: number) =>
    client.post("/queryChargeLog", {
        type,
        pageId,
        itemCount,
        beginTime: 0,
        endTime: 0,
    });

const queryDrawLog = (type: number, pageId: number, itemCount: number) =>
    client.post("/queryDrawLog", {
        type,
        pageId,
        itemCount,
        beginTime: 0,
        endTime: 0,
    });

const querySwapLog = (type: number, pageId: number, itemCount: number) =>
    client.post("/querySwapLog", {
        type,
        pageId,
        itemCount,
        beginTime: 0,
        endTime: 0,
    });

const getLockedCoin = (type: number) => client.post("/getLockedCoin", {type});

const withdrawUnlockedCoin = (type: number, amount: number) => client.post("/withdrawUnlockedCoin", {type, amount});

const queryCoinExchangeLog = (type: number, mode: number, pageId: number, itemCount: number) =>
    client.post("/queryCoinExchangeLog", {type, mode, pageId, itemCount});

const queryUserBetHistoryList = (pageId: number, pageCount: number) => client.post("/queryUserBetHistoryList", {pageId, pageCount});

const queryRewardHistoryList = (pageId: number, pageCount: number) =>
    client.post("/queryRewardHistoryList", {
        pageId,
        pageCount,
    });

const apiWallet = {
    getWalletAddress,
    getChargeActivity,
    updateChargeActivityFlag,
    depositFiat,
    withdrawCrypto,
    withdrawFiat,
    getSwapRate,
    swapCoin,
    queryChargeLog,
    queryDrawLog,
    querySwapLog,
    getLockedCoin,
    withdrawUnlockedCoin,
    queryCoinExchangeLog,
    queryUserBetHistoryList,
    queryRewardHistoryList,
};

export default apiWallet;
